<script setup>
import {ref, onBeforeMount, reactive, nextTick} from "vue"
import YTCard from "@/components/YTCard/YTCard.vue";
import router from "@/router/index.js";
import {getRoute} from "@/hooks/getRoute.js";
import YTAddress from "@/components/YTAddress/index.vue";
import BoxUpload from "@/components/YTBoxUpload/index.vue";
import YTEditor from "@/components/YTEditor/index.vue";
import {addCyclingRoute, editCyclingRoute, getCyclingRoute} from "@/api/cyclingRoute/cyclingRoute.js";
/*获取路由信息，带参则为修改*/
const {route} = getRoute()

// 带参则为修改
const isEdit = ref(false)
onBeforeMount(async () => {
  isEdit.value = Boolean(route.query.cyclingRouteId)
  if (isEdit.value) {
    await getDetail(route.query.cyclingRouteId)
  } else {
    loading.value = false
  }
})

/*获取线路信息*/
const getDetail = async (cyclingRouteId) => {
  try {
    loading.value = true
    const res = await getCyclingRoute(cyclingRouteId)
    Object.assign(ruleForm, res)
    console.log("ruleForm", ruleForm)
    // 反显途经点
    ruleForm.waypointLocations.map(i => {
      waypointLocationsTabs.value.push("zh")
    })
    // 反显地址
    ruleForm.addressCode.push(ruleForm.provinceCode)
    ruleForm.addressCode.push(ruleForm.cityCode)
    ruleForm.addressCode.push(ruleForm.districtCode)
    // 反显线路主图
    boxUploadRef.value.handleReview(ruleForm.mainImages)
    boxUploadEnRef.value.handleReview(ruleForm.mainImagesEn)
    // 反显沿途风景图
    boxUploadScenicImagesRef.value.handleReview(ruleForm.scenicImages)
    // 反显线路发现页推荐封面图
    if (ruleForm.discoverCoverImage) boxUploadDiscoverCoverRef.value.handleReview([ruleForm.discoverCoverImage])
    if (ruleForm.discoverCoverImageEn) boxUploadDiscoverCoverEnRef.value.handleReview([ruleForm.discoverCoverImageEn])
    loading.value = false
  } catch (e) {
    console.log(e)
  }
}

// 表单加载状态
const loading = ref(true);
// 表单组件锚点
const ruleFormRef = ref()
// 表单信息
const ruleForm = reactive({
  routeName: null,
  routeNameEn: "Coming Soon ...",
  routeLength: null,
  routeAltitude: null,
  routeSlope: null,
  province: null,
  provinceCode: null,
  city: null,
  cityCode: null,
  district: null,
  districtCode: null,
  addressCode: [],
  startLocation: {
    name: null,
    nameEn: "Coming Soon ...",
    longitude: null,
    latitude: null
  },
  waypointLocations: [],
  endLongitude: {
    name: null,
    nameEn: "Coming Soon ...",
    longitude: null,
    latitude: null
  },
  mainImages: [],
  mainImagesEn: [],
  discoverCoverImage: [],
  discoverCoverImageEn: [],
  scenicImages: [],
  description: null,
  descriptionImages: [],
  descriptionEn: "Coming Soon ...",
  descriptionEnImages: []
})
// 线路名称校验规则
const checkRouteName = (rule, value, callback) => {
  if (!ruleForm.routeName) {
    return callback(new Error("线路名称（中文）不能为空！"))
  }
  if (!ruleForm.routeNameEn) {
    return callback(new Error("线路名称（English）不能为空！"))
  }
  return callback()
}
// 起点校验规则
const checkStartLocation = (rule, value, callback) => {
  if (!ruleForm.startLocation.name) {
    return callback(new Error("起点（中文）不能为空！"))
  }
  if (!ruleForm.startLocation.nameEn) {
    return callback(new Error("起点（English）不能为空！"))
  }
  return callback()
}
// 途经点校验规则
const checkWaypointLocations = (rule, value, callback) => {
  if (ruleForm.waypointLocations.length > 0) {
    for (let i = 0; i < ruleForm.waypointLocations.length; i++) {
      if (!ruleForm.waypointLocations[i].name) {
        return callback(new Error(`第${i + 1}个途经点（中文）不能为空！`))
      }
      if (!ruleForm.waypointLocations[i].nameEn) {
        return callback(new Error(`第${i + 1}个途经点（English）不能为空！`))
      }
    }
  }
  return callback()
}
// 终点校验规则
const checkEndLocation = (rule, value, callback) => {
  if (!ruleForm.endLongitude.name) {
    return callback(new Error("终点（中文）不能为空！"))
  }
  if (!ruleForm.endLongitude.nameEn) {
    return callback(new Error("终点（English）不能为空！"))
  }
  return callback()
}
// 线路主图校验规则
const checkMainImages = (rule, value, callback) => {
  const listLength = boxUploadRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请上传一张线路中文主图！'))
  }
  return callback()
}
// 线路主图英文校验
const checkMainImagesEn = (rule, value, callback) => {
  const listLength = boxUploadEnRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请上传一张线路英文主图！'))
  }
  return callback()
}
// 线路发现页推荐封面图（中文）校验规则
const checkDiscoverCoverImages = (rule, value, callback) => {
  const listLength = boxUploadDiscoverCoverRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请上传一张线路发现页推荐封面图（中文）！'))
  }
  return callback()
}
// 线路发现页推荐封面图（英文）验规则
const checkDiscoverCoverImagesEn = (rule, value, callback) => {
  const listLength = boxUploadDiscoverCoverEnRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请上传一张线路发现页推荐封面图（英文）！'))
  }
  return callback()
}
// 线路介绍校验规则
const checkDescription = (rule, value, callback) => {
  if (YTEditorRef.value.isEmpty()) {
    return callback(new Error("线路介绍（中文）不能为空"))
  }
  if (YTEditorEnRef.value.isEmpty()) {
    return callback(new Error("线路介绍（English）不能为空"))
  }
  return callback()
}
// 线路位置表单校验规则
const checkAddress = (rule, value, callback) => {
  if (ruleForm.addressCode.length <= 0) {
    return callback(new Error("请选择线路位置！"))
  }
  console.log("ruleForm.addressCode", ruleForm.addressCode)
  return callback()
}
// 表单校验规则
const rules = ref({
  routeName: [
    { required: true, validator: checkRouteName, trigger: "change" }
  ],
  routeLength: [
    { required: true, message: "请输入线路长度！", trigger: "change" }
  ],
  address: [
    { required: true, validator: checkAddress, trigger: "change" }
  ],
  startLocation: [
    { required: true, validator: checkStartLocation, trigger: "change" }
  ],
  waypointLocations: [
    { validator: checkWaypointLocations, trigger: "change" }
  ],
  endLongitude: [
    { required: true, validator: checkEndLocation, trigger: "change" }
  ],
  discoverCoverImage: [
    { required: true, validator: checkDiscoverCoverImages, trigger: "change" }
  ],
  discoverCoverImageEn: [
    { required: true, validator: checkDiscoverCoverImagesEn, trigger: "change" }
  ],
  mainImages: [
    { required: true, validator: checkMainImages, trigger: "change" }
  ],
  mainImagesEn: [
    { required: true, validator: checkMainImagesEn, trigger: "change" }
  ],
  description: [
    { required: true, validator: checkDescription, trigger: "change" }
  ]
})

// 保存校验表单
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, field) => {
    console.log("ruleForm", ruleForm)
    if (valid) {
      await createRoute()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 取消新增
const cancelAdd = () => {
  router.back()
}
// 处理选择所属区域
const handleSelectAddress = (data) => {
  ruleForm.addressCode = data.value
  ruleForm.province = data.label[0]
  ruleForm.provinceCode = data.value[0]
  ruleForm.city = data.label[1]
  ruleForm.cityCode = data.value[1]
  ruleForm.district = data.label[2] ? data.label[2] : null
  ruleForm.districtCode = data.value[2] ? data.value[2] : null
  ruleFormRef.value.validateField("address")
}
// 处理增加途径点
const handleAddWaypointLocations = () => {
  ruleForm.waypointLocations.push({
    name: null,
    nameEn: "Coming Soon ...",
    longitude: null,
    latitude: null
  })
  waypointLocationsTabs.value.push("zh")
}
// 处理删除途经点
const handleRemoveWaypointLocations = (index) => {
  waypointLocationsTabs.value.splice(index, 1)
  ruleForm.waypointLocations.splice(index, 1)
}
// 路线介绍（中文）富文本锚点
const YTEditorRef = ref()
// 路线介绍（English）富文本锚点
const YTEditorEnRef = ref()
// 处理路线介绍（中文）（English）富文本内容改变
const handleDescriptionChange = (txt, imgArr) => {
  console.log("富文本改变txt", txt)
  console.log("富文本改变imgArr", imgArr)
  ruleForm.description = txt
  ruleForm.descriptionImages = imgArr
  ruleFormRef.value.validateField("description")
}
// 处理路线介绍（English）富文本内容改变
const handleDescriptionEnChange = (txt, imgArr) => {
  console.log("En富文本改变")
  ruleForm.descriptionEn = txt
  ruleForm.descriptionEnImages = imgArr
  ruleFormRef.value.validateField("description")
}

/*图片上传相关*/
// 线路主图组件锚点
const boxUploadRef = ref()
// 英文线路主图组件锚点
const boxUploadEnRef = ref()
// 处理线路主图列表删除
const handleImageRemove = (url) => {
  ruleForm.mainImages = url
  ruleFormRef.value.validateField("mainImages")
}
// 处理英文线路主图列表删除
const handleImageEnRemove = (url) => {
  ruleForm.mainImages = url
  ruleFormRef.value.validateField("mainImagesEn")
}
// 处理沿途风景图删除
const handleScenicImagesPicRemove = (url) => {
  ruleForm.scenicImages = url
}
// 处理线路主图上传成功
const handlePicSuccess = (url) => {
  ruleForm.mainImages = []
  ruleForm.mainImages = url
  ruleFormRef.value.validateField("mainImages")
  loading.value = false
}
// 处理英文线路主图上传成功
const handlePicEnSuccess = (url) => {
  ruleForm.mainImagesEn = []
  ruleForm.mainImagesEn = url
  ruleFormRef.value.validateField("mainImagesEn")
  loading.value = false
}
// 沿途风景组件锚点
const boxUploadScenicImagesRef = ref()
// 处理沿途风景图上传成功
const handleScenicImagesPicSuccess = (url) => {
  ruleForm.scenicImages = []
  ruleForm.scenicImages = url
  loading.value = false
}
// 线路发现页推荐封面图（中文）组件锚点
const boxUploadDiscoverCoverRef = ref()
// 线路发现页推荐封面图（英文）组件锚点
const boxUploadDiscoverCoverEnRef = ref()
// 处理线路发现页推荐封面图（中文）列表删除
const handleDiscoverCoverImageRemove = (url) => {
  ruleForm.discoverCoverImage = url
  ruleFormRef.value.validateField("discoverCoverImage")
}
// 处理线路发现页推荐封面图（英文）列表删除
const handleDiscoverCoverImageEnRemove = (url) => {
  ruleForm.discoverCoverImageEn = url
  ruleFormRef.value.validateField("discoverCoverImageEn")
}
// 处理线路发现页推荐封面图（中文）上传成功
const handleDiscoverCoverPicSuccess = (url) => {
  ruleForm.discoverCoverImage = []
  ruleForm.discoverCoverImage = url
  ruleFormRef.value.validateField("discoverCoverImage")
  loading.value = false
}
// 处理线路发现页推荐封面图（英文）上传成功
const handleDiscoverCoverPicEnSuccess = (url) => {
  ruleForm.discoverCoverImageEn = []
  ruleForm.discoverCoverImageEn = url
  ruleFormRef.value.validateField("discoverCoverImageEn")
  loading.value = false
}

/*表单中英文tab相关*/
// 线路名称tab
const routeTab = ref("zh")
// 起点tab
const startLocationTab = ref("zh")
// 途经点tabs
const waypointLocationsTabs = ref([])
// 终点tab
const endLocationTab = ref("zh")
// 线路介绍tab
const descriptionTab = ref("zh")

// 创建线路相关
const createRoute = async () => {
  try {
    loading.value = true
    if (isEdit.value) {
      await editCyclingRoute(ruleForm)
    } else {
      await addCyclingRoute(ruleForm)
    }
    ElMessage.success(isEdit.value ? "修改成功" : "创建成功")
    loading.value = false
    router.push("/listCyclingRoute")
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm container_form mg_b_3"
      :validate-on-rule-change="false"
      size="large">
    <YTCard :title="'基本信息'">
      <template #container>
        <div v-loading="loading">
          <el-form-item label="线路名称：" prop="routeName">
            <el-tabs
                v-model="routeTab"
                type="card"
                class="demo-tabs"
            >
              <el-tab-pane label="中文" name="zh">
                <el-input maxlength="20" show-word-limit style="width: 350px" v-model="ruleForm.routeName" placeholder="例如：大夫山森林公园骑行线路"></el-input>
              </el-tab-pane>
              <el-tab-pane label="English" name="en">
                <el-input maxlength="60" show-word-limit style="width: 350px" v-model="ruleForm.routeNameEn" placeholder="For example: Doctor Mountain Forest Park cycling route"></el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item label="线路长度：" prop="routeLength">
            <el-input-number style="width: 350px" :min="0" :precision="2" v-model="ruleForm.routeLength" placeholder="例如：43.6">
              <template #suffix>
                <span>KM</span>
              </template>
            </el-input-number>
            <span class="tips_default mg_l_1">单位KM</span>
          </el-form-item>
          <el-form-item label="线路海拔：" prop="routeAltitude">
            <el-input-number style="width: 350px" :min="0" :precision="2" v-model="ruleForm.routeAltitude" placeholder="例如：1300">
              <template #suffix>
                <span>M</span>
              </template>
            </el-input-number>
            <span class="tips_default mg_l_1">单位M</span>
          </el-form-item>
          <el-form-item label="线路坡度：" prop="routeSlope">
            <el-input-number style="width: 350px" :min="0" :precision="2" v-model="ruleForm.routeSlope" placeholder="例如：22"></el-input-number>
          </el-form-item>
          <el-form-item label="线路位置：" prop="address">
            <div style="width: 350px">
              <YTAddress v-if="!loading" ref="YTAddressRef" :addressCode="ruleForm.addressCode" :title="'线路位置'" @select="handleSelectAddress"></YTAddress>
            </div>
          </el-form-item>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'节点信息'">
      <template #container>
        <div v-loading="loading">
          <el-form-item label="起 点：" prop="startLocation">
            <el-tabs
                v-model="startLocationTab"
                type="card"
                class="demo-tabs"
            >
              <el-tab-pane label="中文" name="zh">
                <el-input maxlength="50" show-word-limit style="width: 350px" v-model="ruleForm.startLocation.name" placeholder="例如：蕉门河碧道"></el-input>
              </el-tab-pane>
              <el-tab-pane label="English" name="en">
                <el-input maxlength="150" show-word-limit style="width: 350px" v-model="ruleForm.startLocation.nameEn" placeholder="For example: Chiu Mun Ho Bee Road"></el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-divider></el-divider>
          <el-form-item label="途经点：" prop="waypointLocations">
            <div>
              <div class="mg_b_2" v-for="(item, index) in waypointLocationsTabs" :key="`waypointLocations${index}`">
                <el-tabs
                    v-model="waypointLocationsTabs[index]"
                    type="card"
                    class="demo-tabs"
                >
                  <el-tab-pane label="中文" name="zh">
                    <el-input maxlength="50" show-word-limit style="width: 350px" v-model="ruleForm.waypointLocations[index].name" placeholder="例如：百万葵园"></el-input>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right">
                      <v-icon class="cursor-pointer mg_l_1" color="error" icon="mdi-close" @click="handleRemoveWaypointLocations(index)"></v-icon>
                    </el-tooltip>
                  </el-tab-pane>
                  <el-tab-pane label="English" name="en">
                    <el-input maxlength="150" show-word-limit style="width: 350px" v-model="ruleForm.waypointLocations[index].nameEn" placeholder="For example: Million Kwai Garden"></el-input>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right">
                      <v-icon class="cursor-pointer mg_l_1" color="error" icon="mdi-close" @click="handleRemoveWaypointLocations(index)"></v-icon>
                    </el-tooltip>
                  </el-tab-pane>
                </el-tabs>
              </div>
              <div>
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddWaypointLocations"></v-icon>
                <span class="tips_default">路线可选择0或多个途经点。</span>
              </div>
            </div>
          </el-form-item>
          <el-divider v-if="waypointLocationsTabs.length > 0"></el-divider>
          <el-form-item label="终 点：" prop="endLongitude">
            <el-tabs
                v-model="endLocationTab"
                type="card"
                class="demo-tabs"
            >
              <el-tab-pane label="中文" name="zh">
                <el-input maxlength="50" show-word-limit style="width: 350px" v-model="ruleForm.endLongitude.name" placeholder="例如：南沙湿地公园"></el-input>
              </el-tab-pane>
              <el-tab-pane label="English" name="en">
                <el-input maxlength="150" show-word-limit style="width: 350px" v-model="ruleForm.endLongitude.nameEn" placeholder="For example: Nansha Wetland Park"></el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'相关图片'">
      <template #container>
        <div v-loading="loading">
          <el-form-item label="线路发现页推荐封面图（中文）：" prop="discoverCoverImage">
            <BoxUpload ref="boxUploadDiscoverCoverRef" :ali-oss-path="'CYCLING_ROUTE_DISCOVER_COVER_IMAGE'" :width="280" :height="280" :limit="1" :file-size="1" @progress="loading = true" @remove="handleDiscoverCoverImageRemove" @success="handleDiscoverCoverPicSuccess"></BoxUpload>
          </el-form-item>
          <el-form-item label="线路发现页推荐封面图（英文）：" prop="discoverCoverImageEn">
            <BoxUpload ref="boxUploadDiscoverCoverEnRef" :ali-oss-path="'CYCLING_ROUTE_DISCOVER_COVER_IMAGE_EN'" :width="280" :height="280" :limit="1" :file-size="1" @progress="loading = true" @remove="handleDiscoverCoverImageEnRemove" @success="handleDiscoverCoverPicEnSuccess"></BoxUpload>
          </el-form-item>
          <el-form-item label="中文线路主图：" prop="mainImages">
            <div>
              <BoxUpload ref="boxUploadRef" :ali-oss-path="'CYCLING_ROUTE_MAIN_PATH'" :width="1024" :height="576" :limit="1" :file-size="1" @progress="loading = true" @remove="handleImageRemove" @success="handlePicSuccess"></BoxUpload>
              <div class="el-upload__tip">要求有背景与线路简图。</div>
            </div>
          </el-form-item>
          <el-form-item label="英文线路主图：" prop="mainImagesEn">
            <div>
              <BoxUpload ref="boxUploadEnRef" :ali-oss-path="'CYCLING_ROUTE_MAIN_PATH'" :width="1024" :height="576" :limit="1" :file-size="1" @progress="loading = true" @change="handleImageEnRemove" @success="handlePicEnSuccess"></BoxUpload>
              <div class="el-upload__tip">要求有背景与线路简图。</div>
            </div>
          </el-form-item>
          <el-form-item label="沿途风景：" prop="scenicImages">
            <BoxUpload ref="boxUploadScenicImagesRef" :ali-oss-path="'CYCLING_ROUTE_SCENIC_PATH'" :width="1024" :height="576" :limit="20" :file-size="1" @progress="loading = true" @change="handleScenicImagesPicRemove" @success="handleScenicImagesPicSuccess"></BoxUpload>
          </el-form-item>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'具体描述'">
      <template #container>
        <div v-loading="loading">
          <el-form-item label="线路介绍" prop="description">
            <el-tabs
                v-model="descriptionTab"
                type="card"
                class="demo-tabs"
            >
              <el-tab-pane label="中文" name="zh">
                <YTEditor :ali-oss-path="'CYCLING_ROUTE_DESCRIPTION_PATH'" ref="YTEditorRef" :maxPic="10" :prePath="`cyclingRoute/description/images/`" :max-pic-size="6" :maxLength="1000" :reviewTxt="ruleForm.description" @change="handleDescriptionChange"></YTEditor>
              </el-tab-pane>
              <el-tab-pane label="English" name="en">
                <YTEditor :ali-oss-path="'CYCLING_ROUTE_DESCRIPTION_PATH'" ref="YTEditorEnRef" :maxPic="10" :prePath="`cyclingRoute/description/images/`" :max-pic-size="6" :maxLength="1000" :reviewTxt="ruleForm.descriptionEn" @change="handleDescriptionEnChange"></YTEditor>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
        </div>
      </template>
    </YTCard>
    <v-row>
      <v-col cols="4">
        <v-row>
          <v-col cols="6">
            <v-btn @click="cancelAdd">取消</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="primary" :disabled="loading" @click="submit">保存</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </el-form>
</template>

<style scoped>

</style>
